import {
  CollectionEntrySurfaceFieldsFragmentDoc,
  isType,
} from '@spotify/confidence-graphql';
import { createCollectionEntryExtension } from '@spotify/plugin-confidence-collections-react';

import { surfacesPlugin } from '../plugin';
import { surfaceRouteRef } from '../routes';

export const SurfaceCollectionEntryExtension = surfacesPlugin.provide(
  createCollectionEntryExtension({
    id: 'surface',
    resourceType: 'Surface',
    routeRef: surfaceRouteRef,
    fragment: CollectionEntrySurfaceFieldsFragmentDoc,
    predicate: ({ resource }) => isType(resource, 'WorkflowV1Surface'),
    render: () => null,
  }),
);
